export default "__VITE_PUBLIC_ASSET__d3291b50__"